import {Injectable} from '@angular/core';
import {API_URLS} from 'src/environments/env-routes';
import {APIHelper} from 'src/shared/services/api-helper/api-helper.service';
import {UserService} from 'src/shared/services/user/user.service';
import {StorageService} from '../../../shared/services/storage/storage.service';

@Injectable({
  providedIn: 'root'
})
export class AtivitiesService {
  constructor(private api: APIHelper, private userService: UserService, private storage: StorageService) {
  }

  public getUserActivities() {
    return this.api.requestApi({
      action: API_URLS.activities.getUserActivities
    });
  }

  public getSiteActivities(siteId: string) {
    
    const args = 's='+siteId;
    return this.api.requestApi({
      action: API_URLS.activities.getUserActivities,
      queryArgs:args
    });
  }

  public getallnodes() {
    const args = 'filter=all';
    return this.api.requestApi({
      action: API_URLS.stats.getAllnodes,
      queryArgs: args
    });
  }

  public getTasks() {
    const userId = this.userService.user.id;
    const args =
      'authority=' +
      userId +
      '&properties=bpm_priority,bpm_status,bpm_dueDate,bpm_description&exclude=wcmwf:*&skipCount=0&maxItems=50';
    return this.api.requestApi({
      action: API_URLS.activities.gettasks,
      queryArgs: args
    });
  }

  public acceptTask(id: string, data: any): Promise<any> {
    return this.api.requestApi({
      action: API_URLS.activities.acceptTask.replace(':taskId', id.toString()),
      method: 'POST',
      datas: data
    });
  }

  public getImages() {
    return this.api.requestApi({action: API_URLS.images.getimages});
  }

  public getNotaireImages() {
    return this.api.requestApi({action: API_URLS.images.getnotaireimages});
  }

  public formatUrl(id: string) {
    const token = this.storage.getAsync({key: 'token'});

    const args = '?c=force&attachment=true&alf_ticket=' + token;

    return `${window.location.origin}/alfresco/s/api/node/workspace/SpacesStore/${id}/content/thumbnails/imgpreview${args}`;
  }
}
